import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzListModule } from "ng-zorro-antd/list";
import { NzMessageModule } from "ng-zorro-antd/message";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzTagModule } from "ng-zorro-antd/tag";
import { SharedModule } from "../../shared/shared.module";
import { DocumentssModule } from "../documents/documents.module";
import { TransactionsModule } from "../transactions/transactions.module";
import { CustomersDetailsComponent } from "./customer-details/customer-details.component";
import { CustomerInvoiceDetailsComponent } from "./customer-invoice/customer-invoice-details.component";
import { CustomersListComponent } from "./customers-list/customers-list.component";
@NgModule({
  declarations: [
    CustomersListComponent,
    CustomersDetailsComponent,
    CustomerInvoiceDetailsComponent,
  ],
  exports: [
    CustomersListComponent,
    CustomersDetailsComponent,
    CustomerInvoiceDetailsComponent,
  ],
  imports: [
    NzModalModule,
    CommonModule,
    NzDividerModule,
    NzAvatarModule,
    NzAlertModule,
    NzDescriptionsModule,
    NzMessageModule,
    NzDropDownModule,
    NzSpinModule,
    NzListModule,
    NzIconModule,
    NzCollapseModule,
    NzBadgeModule,
    NzTabsModule,
    SharedModule,
    RouterModule,
    NzTableModule,
    NzButtonModule,
    NzFormModule,
    NzSelectModule,
    NzInputModule,
    NzPopconfirmModule,
    NzTagModule,
    FormsModule,
    TransactionsModule,
    DocumentssModule,
  ],
})
export class CustomersModule {}
